export default __webpack_public_path__ + "static/media/alcohol_free.ec8d1b97.jpeg";